(function($) {
    var url = window.location.href;
    $('.CategoriesBar-category--link').each(function() {
        var link = $(this).attr('href');
        if(link == url) {
            $(this).addClass('active');
            $('.CategoriesBar--mobile .CategoriesBar-category--button span').html($(this).text());
        }
    });


    $('.BlogPost-content iframe').each(function() {
        $(this).addClass('BlogPost-content--iframe');
        $(this).wrap("<div class='BlogPost-content--iframe_wrapper'/>");
    });

    var source = $('.BlogPost-content--iframe').attr('src');
    var sourceNew = source + "?rel=0&showinfo=0&modestbranding=1&html5=1&vq=hd720";
    $('.BlogPost-content--iframe').attr('src', sourceNew);

}(jQuery));
